import { Module } from 'vuex';
import type { RootState } from '@/interfaces/store';

interface NotificationsState {
    unacknowledgedCount: number;
}

const state: NotificationsState = {
    unacknowledgedCount: 0,
};

const mutations = {
    setUnacknowledgedCount(state: NotificationsState, count: number) {
        state.unacknowledgedCount = count;
    },
    incrementUnacknowledgedCount(state: NotificationsState) {
        state.unacknowledgedCount++;
    },
    decrementUnacknowledgedCount(state: NotificationsState) {
        if (state.unacknowledgedCount > 0) {
            state.unacknowledgedCount--;
        }
    },
};

const actions = {
    setUnacknowledgedCount(
        { commit }: { commit: (mutation: string, payload: number) => void },
        count: number,
    ) {
        commit('setUnacknowledgedCount', count);
    },
    incrementUnacknowledgedCount({ commit }: { commit: (mutation: string) => void }) {
        commit('incrementUnacknowledgedCount');
    },
    decrementUnacknowledgedCount({ commit }: { commit: (mutation: string) => void }) {
        commit('decrementUnacknowledgedCount');
    },
};

const getters = {
    unacknowledgedCount: (state: NotificationsState) => state.unacknowledgedCount,
};

const notificationsModule: Module<NotificationsState, RootState> = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};

export default notificationsModule;
